import React, { useEffect, useContext, useState } from 'react';

import { ContextoFinanceiro } from '../../../services/financeiro';

import { Spinner } from '../../StyledComponent';

import ExibirExtratoIrrf from '../ExibirExtratoIrrf';

export const GerarExtrato = ({
  contratoSelecionado,
  codCobranca,
  setshowParcelasPagar,
  setGerarExtrato,
  setGerarIrrf,
}) => {
  const [loading, setLoading] = useState(true);

  const [base64Extrato, setBase64Extrato] = useState('');

  const [base64ExtratoWithChecksum, setBase64ExtratoWithChecksum] =
    useState('');
  const { visualizarPdfExtrato } = useContext(ContextoFinanceiro);

  useEffect(() => {
    document.getElementById('divResumoParcelasSelecionadas').style.display =
      'none';
  }, []);

  useEffect(() => {
    if (!codCobranca?.includes('202') && !codCobranca?.includes('203')) {
      getExtrato();
    }
  }, [contratoSelecionado]);

  async function getExtrato() {
    setLoading(true);

    let idsVenda = {
      IdVenda:
        contratoSelecionado?.idVenda || contratoSelecionado?.contrato?.idVenda,
      IdVendaCarteira:
        contratoSelecionado?.idVendaCarteira ||
        contratoSelecionado?.contrato?.idVendaCarteira,
    };

    try {
      let resultGetExtrato = '';
      resultGetExtrato = await visualizarPdfExtrato(idsVenda);

      const base64WithChecksum = resultGetExtrato.data;
      const base64 = base64WithChecksum.split('_')[0];

      setBase64ExtratoWithChecksum(resultGetExtrato.data);
      setBase64Extrato(base64);
      setLoading(false);
    } catch (error) {
      return [];
    }
  }

  if (loading) return <Spinner />;

  return (
    <>
      <ExibirExtratoIrrf
        base64={base64Extrato}
        base64WithChecksum={base64ExtratoWithChecksum}
        tipo='extrato'
        setshowParcelasPagar={setshowParcelasPagar}
        setGerarExtrato={setGerarExtrato}
        setGerarIrrf={setGerarIrrf}
      />
    </>
  );
};

export default GerarExtrato;
